import { Type } from 'class-transformer';
import { Model } from './model';
import { EmailTemplate } from './email_template';

export class EmailTemplateFolder extends Model {
  id: string;

  name: string;

  @Type(() => EmailTemplate)
  templates: EmailTemplate[];
}
